import { Injectable } from '@angular/core';
import { ApiProvider } from '@toro/common/shared/services/new-http/providers/api.http.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DebitBalanceService {
    public sessionId: string;

    constructor(
        private api: ApiProvider,
        private store: Store<AppState>
    ) {}

    public getDebitBalance() {
        try {
            this.fillSessionId();
            return this.api.get('/toro-lumen/v2/finance/debit-balance')   
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    private fillSessionId = () => {
        this.store
            .select(({authentication}) => authentication.currentUser)
            .pipe(
                filter((authentication) => !!authentication),
                take(1)
            )
            .subscribe((user) => {
                this.sessionId = user.sessionId
            })
    }
}
